import type { KeyBindings, QualityProfile, QualityTier, UserSettings } from './types'

/** localStorage 持久化命名空间。 */
export const STORAGE_KEY = 'wild-tides:v1:settings'

/** 默认键位映射（名称 → 多个 KeyboardEvent.code，多个表示任一触发）。 */
export const DEFAULT_KEY_BINDINGS: KeyBindings = {
  forward: ['KeyW', 'ArrowUp'],
  backward: ['KeyS', 'ArrowDown'],
  left: ['KeyA', 'ArrowLeft'],
  right: ['KeyD', 'ArrowRight'],
  jump: ['Space'],
  sprint: ['ShiftLeft', 'ShiftRight'],
  interact: ['KeyE'],
  menu: ['Escape'],
}

/** 默认用户设置。 */
export const DEFAULT_SETTINGS: UserSettings = {
  quality: 'medium',
  autoDegrade: true,
  masterVolume: 1,
  musicVolume: 0.7,
  sfxVolume: 1,
  invertY: false,
  showStats: false,
}

/**
 * 三档画质 profile。后续根据基准测试微调数值。
 */
export const QUALITY_PROFILES: Record<QualityTier, QualityProfile> = {
  low: {
    tier: 'low',
    shadowMapSize: 1024,
    pixelRatio: 1,
    postFx: { bloom: true, ssao: false, dof: false, taa: false },
    forest: { treeCount: 80, grassCount: 2000, drawDistance: 60 },
    ocean: { waveSegments: 96, foam: false, underwater: false },
  },
  medium: {
    tier: 'medium',
    shadowMapSize: 2048,
    pixelRatio: 1.5,
    postFx: { bloom: true, ssao: true, dof: false, taa: false },
    forest: { treeCount: 80, grassCount: 6000, drawDistance: 90 },
    ocean: { waveSegments: 256, foam: true, underwater: false },
  },
  high: {
    tier: 'high',
    shadowMapSize: 4096,
    pixelRatio: 2,
    postFx: { bloom: true, ssao: true, dof: true, taa: true },
    forest: { treeCount: 160, grassCount: 14000, drawDistance: 140 },
    ocean: { waveSegments: 384, foam: true, underwater: true },
  },
}

/** 物理 / 渲染常量。 */
export const GRAVITY = -9.81 as const
export const FIXED_TIMESTEP = 1 / 60

/** 自动降级阈值。 */
export const PERF_DOWNGRADE_FPS = 45
export const PERF_UPGRADE_FPS = 58
/** 连续低于阈值多少帧才降级（避免抖动）。 */
export const PERF_SAMPLE_FRAMES = 120
